export const organizationTypes = ["unknown", "government", "communityPartner", "merchant", "city"] as const;

export type OrganizationType = (typeof organizationTypes)[number];

export interface OrganizationMapConfig {
  center: [number, number];
  max_bounds: [[number, number], [number, number]];
  zoom: number;
}

export interface Organization {
  id: string;
  name: string;
  organization_type: OrganizationType | null;
  state: string | null;
  icon_url: string | null;
  boundary_geojson_url: string | null;
  map_config: OrganizationMapConfig | null;
  created_at: string;
  updated_at: string;
}

export interface OrganizationPayload {
  name: string;
  organization_type?: OrganizationType | null;
  state?: string | null;
  image?: File | null;
  boundary_geojson?: File | null;
  map_center_latitude?: number;
  map_center_longitude?: number;
  map_max_bounds_south_latitude?: number;
  map_max_bounds_west_longitude?: number;
  map_max_bounds_north_latitude?: number;
  map_max_bounds_east_longitude?: number;
  map_zoom?: number;
}

export interface OrganizationListResponse {
  list: Organization[];
  paging: {
    index: number;
    size: number;
    total: number;
  } | null;
}
